/* eslint-disable no-unused-vars */
import { useState } from 'react';
import { $, fd, td } from '../theme';
import Ic from '../Icon';

export default function VacancyTracker({ vacancies = [], onAdd, onUpdate }) {
  const [showAdd, setShowAdd] = useState(false);
  const [saving,  setSaving]  = useState(false);
  const [form, setForm] = useState({ unit: '', property_name: '', monthly_rent: '', vacant_since: td(), notes: '' });

  const vacant = vacancies.filter(v => v.status === 'vacant');
  const leased = vacancies.filter(v => v.status === 'leased');
  const incomeLoss = vacant.reduce((s, v) => s + (v.monthly_rent || 0), 0);

  const daysSince = dateStr => {
    if (!dateStr) return 0;
    return Math.max(0, Math.floor((Date.now() - new Date(dateStr)) / 86400000));
  };

  const addVacancy = async () => {
    if (!form.unit || !form.property_name) return;
    setSaving(true);
    if (onAdd) await onAdd({ ...form, monthly_rent: parseFloat(form.monthly_rent) || 0, status: 'vacant' });
    setForm({ unit: '', property_name: '', monthly_rent: '', vacant_since: td(), notes: '' });
    setShowAdd(false);
    setSaving(false);
  };

  const markLeased = async v => { if (onUpdate) await onUpdate(v.id, { status: 'leased' }); };
  const markVacant = async v => { if (onUpdate) await onUpdate(v.id, { status: 'vacant', vacant_since: td() }); };

  return (
    <div>
      <div className="sg3">
        <div className="st">
          <div className="stb" style={{ background:'linear-gradient(90deg,#f85149,#fc7b7b)' }}/>
          <small>Vacant Units</small>
          <div className="stv">{vacant.length}</div>
          <div className="sts">of {vacancies.length} total</div>
        </div>
        <div className="st">
          <div className="stb" style={{ background:'linear-gradient(90deg,#f97316,#fb923c)' }}/>
          <small>Monthly Income Loss</small>
          <div className="stv">{$(incomeLoss)}</div>
          <div className="sts">uncollected</div>
        </div>
        <div className="st">
          <div className="stb" style={{ background:'linear-gradient(90deg,#22c55e,#4ade80)' }}/>
          <small>Leased Units</small>
          <div className="stv">{leased.length}</div>
          <div className="sts">occupied</div>
        </div>
      </div>

      <div className="card">
        <div className="card-hd">
          <h3>Vacancy Board</h3>
          <button className="btn btn-g" style={{ padding:'6px 14px', fontSize:12 }} onClick={() => setShowAdd(true)}>
            <Ic n="plus" s={13}/> Add Unit
          </button>
        </div>

        {vacancies.length === 0 ? (
          <div style={{ textAlign:'center', padding:'40px 20px', color:'#484f58' }}>
            <Ic n="build" s={36} c="#484f58"/>
            <div style={{ marginTop:12, fontSize:13 }}>No units tracked yet. Add a unit to start monitoring vacancies.</div>
          </div>
        ) : (
          <div className="tw">
            <table>
              <thead>
                <tr><th>Unit</th><th>Property</th><th>Rent</th><th>Vacant Since</th><th>Days Vacant</th><th>Status</th><th>Action</th></tr>
              </thead>
              <tbody>
                {vacancies.map(v => {
                  const isVacant = v.status === 'vacant';
                  const days     = isVacant ? daysSince(v.vacant_since) : 0;
                  return (
                    <tr key={v.id}>
                      <td style={{ fontWeight:600, color:'#fff' }}>Unit {v.unit}</td>
                      <td style={{ color:'#8b949e' }}>{v.property_name || '—'}</td>
                      <td style={{ color:'#f5f0e8' }}>{$(v.monthly_rent || 0)}</td>
                      <td style={{ color:'#8b949e', fontSize:12 }}>{isVacant ? fd(v.vacant_since) : '—'}</td>
                      <td>
                        {isVacant
                          ? <span className={`b ${days > 30 ? 'br' : days > 14 ? 'by' : 'b'}`}>{days}d</span>
                          : <span className="b bg">Leased</span>
                        }
                      </td>
                      <td><span className={`b ${isVacant ? 'br' : 'bg'}`}>{isVacant ? 'Vacant' : 'Leased'}</span></td>
                      <td>
                        {onUpdate && (
                          isVacant
                            ? <button className="btn btn-ok" style={{ padding:'4px 10px', fontSize:11 }} onClick={() => markLeased(v)}>Mark Leased</button>
                            : <button className="btn btn-d"  style={{ padding:'4px 10px', fontSize:11 }} onClick={() => markVacant(v)}>Mark Vacant</button>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {showAdd && (
        <div className="mov" onClick={e => e.target === e.currentTarget && setShowAdd(false)}>
          <div className="modal">
            <div className="mhd">
              <h2>Add Vacant Unit</h2>
              <button className="btn btn-gh" style={{ padding:'5px 9px' }} onClick={() => setShowAdd(false)}><Ic n="x" s={15}/></button>
            </div>
            <div className="mbdy">
              <div className="fg">
                <div className="fi fi-f">
                  <label>Unit Number</label>
                  <input value={form.unit} onChange={e => setForm(p => ({...p, unit: e.target.value}))} placeholder="e.g. 2A" autoFocus/>
                </div>
                <div className="fi fi-f">
                  <label>Property Name</label>
                  <input value={form.property_name} onChange={e => setForm(p => ({...p, property_name: e.target.value}))} placeholder="e.g. Elm Ridge"/>
                </div>
                <div className="fi">
                  <label>Monthly Rent ($)</label>
                  <input type="number" value={form.monthly_rent} onChange={e => setForm(p => ({...p, monthly_rent: e.target.value}))} placeholder="0"/>
                </div>
                <div className="fi">
                  <label>Vacant Since</label>
                  <input type="date" value={form.vacant_since} onChange={e => setForm(p => ({...p, vacant_since: e.target.value}))}/>
                </div>
                <div className="fi fi-f">
                  <label>Notes (optional)</label>
                  <input value={form.notes} onChange={e => setForm(p => ({...p, notes: e.target.value}))} placeholder="e.g. Needs carpet replacement"/>
                </div>
              </div>
              <div style={{ display:'flex', gap:10, justifyContent:'flex-end', marginTop:12 }}>
                <button className="btn btn-gh" onClick={() => setShowAdd(false)}>Cancel</button>
                <button className="btn btn-g" onClick={addVacancy} disabled={!form.unit || !form.property_name || saving}>
                  <Ic n="plus" s={14}/>{saving ? 'Saving...' : 'Add Unit'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
